/**
 * 系统用户接口列表
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const examinGoodsAlone = {
    //获取验货单列表信息（出库单）
    getExamineMainAloneList(params) {
        return axios.post('/order/examineGoodsAlone/getExamineMainAloneList', qs.stringify(params));
    },
    //获取验货单商品列表信息（出库单）
    getExamineGoodsAloneList(params) {
        return axios.post('/order/examineGoodsAlone/getExamineGoodsAloneList', qs.stringify(params));
    },
    //验收验货单商品信息（出库单）
    updateExamineGoodsNumAlone(params) {
        return axios.post('/order/examineGoodsAlone/updateExamineGoodsNumAlone', qs.stringify(params));
    },
    //提交验货单信息（出库单）
    submitExamineMainAlone(params) {
        return axios.post('/order/examineGoodsAlone/submitExamineMainAlone', qs.stringify(params));
    },
    //获取验货单详情信息（出库单）
    getExamineMainDetailAloneList(params) {
        return axios.post('/order/examineGoodsAlone/getExamineMainDetailAloneList', qs.stringify(params));
    },
    //一键验收验货单商品信息（出库单）接口
    batchUpdateExamineGoodsNumAlone(params) {
        return axios.post('/order/examineGoodsAlone/batchUpdateExamineGoodsNumAlone', qs.stringify(params));
    },
}

export default examinGoodsAlone;


// WEBPACK FOOTER //
// ./src/request/api/order/examinGoods_alone.js